import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { intlLocaleFor } from '@self-restaurant/shared'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * #428: locale SÓ para o Intl (formato de preços/datas) — língua base + país
 * do restaurante ('pt' + 'PT' → «12,50 €»). Nunca gravar nem mostrar.
 */
export function priceLocaleOf(
  lang: string,
  country?: string | null,
  cfg?: { country_code?: string | null } | null,
): string {
  return intlLocaleFor(lang, country ?? cfg?.country_code ?? null)
}

/**
 * Moeda de apresentação do tenant (#419/#413): vem do PAÍS do restaurante
 * (`cfg.currency`, derivado de tenants.country_code pela API) — NUNCA do
 * idioma. Quem não lê /admin/config (garçom) usa o `/menu/restaurant`
 * público. Fallback histórico: 'BRL'.
 */
export function tenantCurrency(
  cfg?: { currency?: string | null } | null,
  publicCurrency?: string | null,
): string {
  return cfg?.currency ?? publicCurrency ?? 'BRL'
}

export function formatCents(cents: number, currency = 'BRL', locale = 'pt'): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(cents / 100)
}

export function parseCents(value: string): number {
  // Aceita "29,90" ou "29.90" ou "2990"
  const cleaned = value.replace(/[^0-9,\.]/g, '').replace(',', '.')
  const float = parseFloat(cleaned)
  return isNaN(float) ? 0 : Math.round(float * 100)
}

export const DAY_NAMES = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado']
